$(document).ready(function() {

    var IntCol = $('#international');
    var USCol = $('#country-US');
    //var cname = "GlobalE_Data";
    var cname = "localization";
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            var cookie = c.substring(name.length, c.length);
        }
    }
    cookie = cookie.includes("US");

    if( cookie == true ) {
        $(IntCol).remove();
    } else {
        $(USCol).remove();
    }
});